import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent } from '@web/shared/ui';
import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import {
  PublicCartAddButtonComponent,
  PublicSales,
} from '@web/shared/module/shop';
import { PublicAvailableProductType } from '../../enums/public-available-product-type';

@Component({
  selector: 'app-public-products-for-sale-tile',
  imports: [
    ImageThumbnailComponent,
    NgOptimizedImage,
    RouterLinkComponent,
    PublicCartAddButtonComponent,
  ],
  templateUrl: './public-products-for-sale-tile.component.html',
  styleUrl: './public-products-for-sale-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicProductsForSaleTileComponent {
  public readonly imageSrc = input.required<string>();
  public readonly imageAlt = input.required<string>();
  public readonly name = input.required<string>();
  public readonly slug = input.required<string>();
  public readonly type = input.required<PublicAvailableProductType>();
  public readonly sales = input.required<PublicSales>();

  /* prettier-ignore */
  protected readonly params = this.paramsSignal();
  protected readonly route = this.routeSignal();
  protected readonly buyLabel = this.buyLabelSignal();

  private paramsSignal(): Signal<RouterLinkParams> {
    return computed(() => {
      return {
        [RouteParam.Slug]: this.slug(),
      };
    });
  }

  private routeSignal(): Signal<Route> {
    return computed(() => {
      switch (this.type()) {
        case PublicAvailableProductType.Box:
          return Route.PL_BoxDetails;

        case PublicAvailableProductType.Product:
          return Route.PL_ProductDetails;

        default:
          return Route.PL_BoxDetails;
      }
    });
  }

  private buyLabelSignal(): Signal<string> {
    return computed(() => {
      switch (this.type()) {
        case PublicAvailableProductType.Box:
          return 'Kup box';

        case PublicAvailableProductType.Product:
          return 'Kup produkt';

        default:
          return 'Kup produkt';
      }
    });
  }
}
